<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="workgrpmenu_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="h_info">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 sp-0" ttHeading="h_functions">
                        <ng-container *ngTemplateOutlet="buttons"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">

                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="workgrp_keyno" [ttModel]="menu.workgrp_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="businessco_companyname" [ttModel]="menu.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="factory_name" [ttModel]="menu.factory_name" ttReadonly></tt-input>
        <tt-input ttLabel="workgrp_name" [ttModel]="menu.workgrp_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="active" [(ttModel)]="menu.active"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'workgrpmenu_edit'" [ttGoto]="'workgrp'" [ttGotoParms]="{ workgrp_keyno: menu.workgrp_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'workgrpmenu_shiftview'" [ttGoto]="'shiftview'" [ttGotoParms]="{ labour_no: 'W' + menu.workgrp_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'workgrpmenu_equipmentlist'" [ttBadge]="menu.nbr_of_equipments" [ttGoto]="'equipmentlist'" [ttGotoParms]="{ argtype: 'workgrp_keyno', argvalue: menu.workgrp_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>
